$mol_view_tree2_to_js_test_ex_left_read_only_foo $mol_object
	bar1 <= bar2? 1
